export var FEDRAMP_MODERATE = 'fedramp-moderate';
export var COMMERCIAL = 'commercial';
export var FEDRAMP_FEDEX = 'fedramp-fedex';
export var STAGING = 'stg';
export var PRODUCTION = 'prod';